import React, { Component } from 'react';
import InlineSVG from 'svg-inline-react';
import { Link, browserHistory } from 'react-router';

import { connect } from 'react-redux';
import { openDrawer, closeDrawer } from 'actions/drawer';
import { openModal } from 'actions/modal';

import { firebaseConnect, helpers } from 'react-redux-firebase';
const { pathToJS } = helpers;
import { VisibleOnlyAdmin, VisibleOnlyCustomer, VisibleOnlyActiveOrder } from 'components/AuthenticatedComponent';
import OrderPanel from 'components/OrderPanel';
import Loader from 'components/Loader/Loader';

import Logo from 'assets/icons/logo';
import LogoutIcon from 'assets/icons/logout';
import PlusIcon from 'assets/icons/plus';
import ListIcon from 'assets/icons/list';
import MoreIcon from 'assets/icons/more';
import CircleIcon from 'assets/icons/circle';
import BoxIcon from 'assets/icons/box';
import AppleIcon from 'assets/icons/apple';
import GraduationIcon from 'assets/icons/graduation-cap';
import UserIcon from 'assets/icons/user';
import BarsIcon from 'assets/icons/bars';
import BooksIcon from 'assets/icons/books';
import FileIcon from 'assets/icons/file';
import Button from './Button';
import Panel from './Panel';

import 'sass/components/sidebar';

class Sidebar extends Component {

	refreshApp (event) {
		location.reload();
	}

	handleLogout (event) {
		event.preventDefault();
		this.props.firebase.logout();
		browserHistory.replace('/');
	}

	userInitials (name) {
		if(name){
			return name.split(' ').map( (word)=> {
				return word.toUpperCase().charAt(0);
			}).join('').substring(0,2);
		}
        return '';
	}

	render () {
		const { auth } = this.props;

		return (
			<div className={!this.props.user.loading && !this.props.user.disabled ? ('sidebar') : ('sidebar disabled')}>
				<div className="sidebar-content">
					<div onClick={this.refreshApp.bind(this)} className="logo">
						<div className="container">
							<InlineSVG src={Logo} element="span" className="icon" />
						</div>
					</div>

					{!this.props.user.loading && !this.props.user.disabled ? (
						<nav>
							<div className="container">
								<ul>
									<VisibleOnlyAdmin>
										<li>
											<Link className={this.props.location.pathname === '/orders' ? 'nav-item active' : 'nav-item' } to="/orders">
												<InlineSVG src={ListIcon} element="span" className="icon" />
												<span className="label">Orders</span>
											</Link>
										</li>
									</VisibleOnlyAdmin>
									<VisibleOnlyAdmin>
										<li>
											<Link className={this.props.location.pathname === '/customers' ? 'nav-item active' : 'nav-item' } to="/customers">
												<InlineSVG src={AppleIcon} element="span" className="icon" />
												<span className="label">Customers</span>
											</Link>
										</li>
									</VisibleOnlyAdmin>

									<li>
										<Link className={this.props.location.pathname === '/classrooms' ? 'nav-item active' : 'nav-item' } to="/classrooms">
											<InlineSVG src={GraduationIcon} element="span" className="icon" />
											<span className="label">Classrooms</span>
										</Link>
									</li>

									<li>
										<Link className={this.props.location.pathname === '/products' ? 'nav-item active' : 'nav-item' } to="/products">
											<InlineSVG src={BoxIcon} element="span" className="icon" />
											<span className="label">Products</span>
										</Link>
									</li>
									<VisibleOnlyAdmin>
									<li>
										<Link className={this.props.location.pathname === '/users' ? 'nav-item active' : 'nav-item' } to="/users">
											<InlineSVG src={UserIcon} element="span" className="icon" />
											<span className="label">Users</span>
										</Link>
									</li>
									</VisibleOnlyAdmin>
									<li>
										<Link className={this.props.location.pathname === '/metrics' ? 'nav-item active' : 'nav-item' } to="/metrics">
											<InlineSVG src={BarsIcon} element="span" className="icon" />
											<span className="label">Metrics</span>
										</Link>
									</li>
									<VisibleOnlyActiveOrder>
										<VisibleOnlyCustomer>
											<li>
												<Link className={this.props.location.pathname === '/supplementalmaterials' ? 'nav-item active' : 'nav-item' } to="/supplementalmaterials">
													<InlineSVG src={BooksIcon} element="span" className="icon" />
													<span className="label">Supplemental Materials</span>
												</Link>
											</li>
										</VisibleOnlyCustomer>
									</VisibleOnlyActiveOrder>
                                    <VisibleOnlyAdmin>
                                        <li>
                                            <Link className={this.props.location.pathname === '/TermsConditions' ? 'nav-item active' : 'nav-item' } to="/TermsConditions">
                                                <InlineSVG src={FileIcon} element="span" className="icon" />
                                                <span className="label">Terms & Conditions</span>
                                            </Link>
                                        </li>
                                    </VisibleOnlyAdmin>
									<VisibleOnlyAdmin>
										<li>
											<Link className={this.props.location.pathname === '/signup' ? 'nav-item active' : 'nav-item' } to="/signup">
												<InlineSVG src={PlusIcon} element="span" className="icon" />
												<span className="label">Signup</span>
											</Link>
										</li>
									</VisibleOnlyAdmin>
								</ul>
							</div>
						</nav>

					) : (
						<nav className="loading">
							<div className="container">
								<ul>
									<li>
										<Link className="nav-item" to="/orders">
											<InlineSVG src={CircleIcon} element="span" className="icon" />
											<div className="label"><span className="loading-text"/></div>
										</Link>
									</li>
									<li>
										<Link className="nav-item" to="/orders">
											<InlineSVG src={CircleIcon} element="span" className="icon" />
											<div className="label"><span className="loading-text wide"/></div>
										</Link>
									</li>
									<li>
										<Link className="nav-item" to="/orders">
											<InlineSVG src={CircleIcon} element="span" className="icon" />
											<div className="label"><span className="loading-text narrow"/></div>
										</Link>
									</li>
									<li>
										<Link className="nav-item" to="/orders">
											<InlineSVG src={CircleIcon} element="span" className="icon" />
											<div className="label"><span className="loading-text"/></div>
										</Link>
									</li>
								</ul>
							</div>
						</nav>
					)}

					{!this.props.user.loading ? (
						<Link to="/account" className="account">
							<div className="container">
								<div className="avatar">{this.props.profile ? this.userInitials(this.props.profile.name) : ''}</div>
								<div className="label">
									<div className="name">{this.props.profile && this.props.profile.name ? this.props.profile.name : false}</div>
									<div className="email">{auth && auth.email ? auth.email : false}</div>
								</div>
								<div className="logout">
									<Button
										buttonClass="circle tiny transparent"
										icon={LogoutIcon}
										tooltipText="Log Out"
										tooltipPosition="top"
										onClick={this.handleLogout.bind(this)}
									/>
								</div>
							</div>
						</Link>
					) : (
						<div className="account loading">
							<div className="container">
								<div className="avatar">
									<Loader color="dark" />
								</div>
								<div className="label">
									<div className="name"><span className="loading-text-md"/></div>
									<div className="email"><span className="loading-text-md narrow"/></div>
								</div>
							</div>
						</div>
					) }

				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return { user : state.user };
};

const mapDispatchToProps = (dispatch) => {
	return {
		openDrawer :  (panel) => { dispatch(openDrawer(panel)); },
		closeDrawer : () => { dispatch(closeDrawer()); },
		openModal : () => { dispatch(openModal()); }
	};
};

const fbWrappedComponent = firebaseConnect()(Sidebar);

const connectAuth = connect(
    ({ firebase }) => {
        return{
            profile: pathToJS(firebase, 'profile'),
        };
    }
)(fbWrappedComponent);

const connectStore = connect(
	mapStateToProps)(connectAuth);

export default connect(
	({ firebase }) => ({
		authError: pathToJS(firebase, 'authError'),
		auth: pathToJS(firebase, 'auth')
	}),
	mapDispatchToProps
)(connectStore);







// WEBPACK FOOTER //
// ./js/components/Sidebar.js